const tooltips = {
  customIndicator: (
    <>
      <strong>&quot;Custom&quot;</strong> indicates that a package&apos;s configuration differs from the defaults
      provided by the template it was created from.
    </>
  ),
};

export default tooltips;
